import styled from '@emotion/styled/macro';

import ContractForm from '../../Forms/ContractForm/ContractForm';

export const StyledContractForm = styled(ContractForm)`
  margin-top: 1.5rem;
`;
